import Swiper from 'swiper/bundle';
export default class MeetTheTeamSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-meet-the-team-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {
        if (this.settings.$slider.length) {

            // Thumbnail Navigation for the Meet the Team Slider
            const swiper = new Swiper(".js-meet-the-team-slider-nav", {
                spaceBetween: 10,
                slidesPerView: 2,
                loop: true,
                slideToClickedSlide: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                autoScrollOffset: 1,

                breakpoints: {
                    500: {
                        spaceBetween: 20,
                        slidesPerView: 3,
                    },
                    1280: {
                        spaceBetween: 40,
                        slidesPerView: 4,
                    }
                }
            });

            // Main Meet the Team Slider
            new Swiper(".js-meet-the-team-slider", {
                spaceBetween: 10,
                loop: true,
                navigation: {
                    prevEl: ".js-meet-the-team-slider-prev",
                    nextEl: ".js-meet-the-team-slider-next",
                },
                pagination: {
                    el: ".swiper-pagination",
                    type: "progressbar",
                },
                thumbs: {
                    swiper: swiper,
                },
            });

            swiper.on('click', (swiper, e) => {
               e.preventDefault();

               // Get the clicked index
               let clickIndex = swiper.clickedIndex;
               console.log('clicked index:' + clickIndex);

               // Moving the active slide to the left by 1 slide
               let newIndex = clickIndex - 1;
               console.log('new index:' + newIndex);

                // If the new index is less than 0, set the index back to 0 to prevent any errors
               if(newIndex < 0) newIndex = 0;
               console.log('new index if 0:' + newIndex);

                // Move the main slider to the new index
                swiper.slideTo(newIndex, 1000);

            });
        }
    }

};

new MeetTheTeamSlider();